module.exports = __webpack_public_path__ + "img/himo-logo.9dacaeb2.png";